function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.83329 16.0418C5.83329 16.387 6.11312 16.6668 6.45829 16.6668H11.6666C13.3155 16.6668 14.5867 15.9812 15.4331 14.9383C16.2672 13.9107 16.6666 12.5667 16.6666 11.2502C16.6666 9.93358 16.2672 8.58966 15.4331 7.56204C14.5867 6.51904 13.3155 5.83349 11.6666 5.83349H6.30051L8.35854 3.77544C8.60262 3.53136 8.60262 3.13563 8.35854 2.89155C8.11449 2.64748 7.71876 2.64748 7.47468 2.89155L4.34968 6.01655C4.10561 6.26063 4.10561 6.65636 4.34968 6.90044L7.47468 10.0254C7.71876 10.2695 8.11449 10.2695 8.35854 10.0254C8.60262 9.78133 8.60262 9.38566 8.35854 9.14158L6.30051 7.08349H11.6666C12.9345 7.08349 13.8507 7.59586 14.4626 8.34974C15.0869 9.11899 15.4166 10.1709 15.4166 11.2502C15.4166 12.3294 15.0869 13.3813 14.4626 14.1506C13.8507 14.9045 12.9345 15.4168 11.6666 15.4168H6.45829C6.11312 15.4168 5.83329 15.6967 5.83329 16.0418Z",
  fill: "white"
});

var SvgUndo = function SvgUndo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUndo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undo.eb581f99.svg";
export { ForwardRef as ReactComponent };